// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__sGvqJ","inner":"Form_inner__2P2rd","range":"Form_range__2tonh","name":"Form_name__1e4H_","actions":"Form_actions__2qpbK"};